import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import WhiteboardCanvas from './WhiteboardCanvas';

const Whiteboard = ({
    backgroundImage,
    showWhiteboard,
    activeTool,
    color,
    thickness,
    canvasRef,
    onUnsavedChanges,
    setToolbarExpanded,
    onColorUsed,
    suppressUnsavedChangesRef,
    onCanvasModified, // Phase 1: Track canvas changes for combined mode
}) => {
    // Cleanup when toggled OFF
    useEffect(() => {
        if (!showWhiteboard && canvasRef.current) {
            canvasRef.current.dispose();
            canvasRef.current = null;
        }
    }, [showWhiteboard]);

    // Detect if user has drawn anything new (possible for changes in the future)
    useEffect(() => {
        if (canvasRef.current) {
            const markUnsaved = () => {
                if (suppressUnsavedChangesRef?.current) return;
                if (onUnsavedChanges) onUnsavedChanges(true);
                if (onCanvasModified) onCanvasModified(true); // Phase 1: Notify combined mode
            };
            const handleObjectAdded = () => {
                markUnsaved();
            };
            const handleObjectRemoved = () => {
                markUnsaved();
            };
            const handleObjectModified = () => {
                markUnsaved();
            };

            canvasRef.current.on('object:added', handleObjectAdded);
            canvasRef.current.on('object:removed', handleObjectRemoved);
            canvasRef.current.on('object:modified', handleObjectModified);

            return () => {
                if (canvasRef.current) {
                    canvasRef.current.off('object:added', handleObjectAdded);
                    canvasRef.current.off('object:removed', handleObjectRemoved);
                    canvasRef.current.off('object:modified', handleObjectModified);
                }
            };
        }
    }, [canvasRef, onUnsavedChanges, onCanvasModified, suppressUnsavedChangesRef]);

    return (
        <div
            className={`whiteboard-container ${showWhiteboard ? 'active' : ''}`}
            style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                pointerEvents: showWhiteboard ? 'auto' : 'none',
                zIndex: showWhiteboard ? 999 : 10,
                background: 'transparent',
            }}
        >
            {/* Canvas aligned with the main illustration */}
            {showWhiteboard && (
                <Box
                    className="whiteboard-canvas-wrapper"
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        zIndex: 5,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        pointerEvents: 'auto',
                    }}
                >
                    <WhiteboardCanvas
                        canvasRef={canvasRef}
                        setToolbarExpanded={setToolbarExpanded}
                        backgroundImage={backgroundImage}
                        activeTool={activeTool}
                        color={color}
                        thickness={thickness}
                        onColorUsed={onColorUsed}
                    />
                </Box>
            )}
        </div>
    );
};

export default Whiteboard;
